import { uiText } from '../../i18n/uiText';
import React, { useState } from 'react';
import { Archive, File, FileImage, FileSpreadsheet, FileText, Presentation, Trash2 } from 'lucide-react';
import { formatFileSize, getFileKind, fileKindLabel } from '../../utils/fileMeta';
import { formatDate } from '../../utils/formatters';
import AttachmentPreviewModal from './AttachmentPreviewModal';

export default function AttachmentItem({ file, onDelete = null, deleting = false, context = null, onOpenContext, onPreview }) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const url = file.url || `/uploads/${file.filename}`;
  const kind = getFileKind(file);
  const canPreview = Boolean(file.is_previewable);
  const Icon = {
    image: FileImage,
    spreadsheet: FileSpreadsheet,
    document: FileText,
    presentation: Presentation,
    archive: Archive,
    file: File,
  }[kind] || File;

  return (
    <>
      <div className="ap-attachment" role="group" aria-label={file.original_name || uiText("Вложение")}>
        <div className="ap-attachment__main">
          <div className="ap-attachment__icon" aria-hidden="true"><Icon size={20} /></div>
          <div style={{ minWidth: 0 }}>
            <div className="ap-attachment__name">{file.original_name || file.filename || uiText("Вложение")}</div>
            <div className="ap-attachment__meta">{fileKindLabel(file)} · {formatFileSize(file.file_size)}{file.uploaded_at ? ` · ${formatDate(file.uploaded_at)}` : ''}{file.uploaded_by_name ? ` · ${file.uploaded_by_name}` : ''}</div>
            {context && (onOpenContext ? <button type="button" className="ap-attachment__context" onClick={onOpenContext}>{context}</button> : <div className="ap-attachment__meta">{context}</div>)}
          </div>
        </div>
        <div className="ap-attachment__actions">
          {canPreview && <button type="button" className="ap-button ap-button--secondary ap-button--sm" onClick={() => onPreview ? onPreview(file) : setPreviewOpen(true)}>{uiText("Предпросмотр")}</button>}
          <a className="ap-button ap-button--secondary ap-button--sm" href={url} target="_blank" rel="noreferrer">{uiText("Открыть")}</a>
          <a className="ap-button ap-button--secondary ap-button--sm" href={url} target="_blank" rel="noreferrer" download={file.original_name}>{uiText("Скачать")}</a>
          {onDelete ? (
            <button
              type="button"
              className="ap-button ap-button--secondary ap-button--sm ap-attachment__delete"
              onClick={() => onDelete(file)}
              disabled={deleting}
              aria-label={uiText("Удалить файл {v0}", {v0: (file.original_name || file.filename || '')})}
              title={uiText("Удалить ошибочно загруженный файл")}
            >
              <Trash2 size={14} /> {deleting ? uiText("Удаление…") : uiText("Удалить")}
            </button>
          ) : null}
        </div>
      </div>
      {previewOpen && <AttachmentPreviewModal file={file} onClose={() => setPreviewOpen(false)} />}
    </>
  );
}
